<!--
Author: TangChen
Date: 2018-10-17
Desc: 绑定交易账户，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-bind-acct-way bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <div class="bind-acct-way">
            <el-row class="bind-acct-way-box" :gutter="56">
                <el-col :span="9" :offset="3">
                    <el-card shadow="hover">
                        <div v-on:click.once="$router.push({name: 'bindnewacct'})">
                            <span class=" bind-way-tit">还未开立交易账号</span>
                            <p class="bind-way-intro">
                                如果您未曾在我司进行过开户操作，请选择此项，我们将为您开立交易账号并自动绑定
                            </p>
                            <p class="bind-way-condition">
                                需要进行银行卡实名鉴权
                            </p>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="9">
                    <el-card shadow="hover">
                        <div v-on:click.once="$router.push({name: 'bindoldacct'})">
                            <span class=" bind-way-tit">已有交易账号</span>
                            <p class="bind-way-intro">
                                如果您曾在我司柜台、旧版网上交易/APP/微信上进行过开户操作，请选择此项
                            </p>
                            <p class="bind-way-condition">
                                需要验证您的开户证件和交易密码
                            </p>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <div class="bind-acct-way-hint">
                <span class="like-a" v-on:click.prevent="$router.push({name: 'bindnewacct'})">我不清楚是否已有交易账号?</span>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
export default {
    name: "BindAcctWay",
    components: {
        navTips
    },
    mixins: [mixin],
    data () {
        return {
            titTips: {
                tit: "您还未绑定交易账号",
                text: "进行基金买入、卖出、定投等操作需要绑定交易账号",
                cla: "bank"
            }
        };
    },
    methods: {
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.bizcomp-bind-acct-way {
  .bind-acct-way {
    padding-bottom: 90px;
    overflow: hidden;
    .bind-acct-way-box {
      padding: 45px 0;
      .el-col .el-card {
        border-radius: 7px;
        .el-card__body {
          cursor: pointer;
          .bind-way-tit {
            font-size: $f24;
            color: $text-color2;
            line-height: 50px;
          }
          .bind-way-intro {
            line-height: 18px;
            color: $text-color7;
          }
          .bind-way-condition {
            line-height: 24px;
            color: $text-color9;
            padding: 13px 0;
          }
        }
      }
    }
    .bind-acct-way-hint {
      text-align: center;
    }
  }
}
</style>
